import loggerLocal from '@/utils/loggerLocal';
import { DBRole } from '@functions/models/DBEnum';
import type { IntCompanyData } from '@functions/models/interfaces/intCompany';
import type { IntLinkedCompanyData } from '@functions/models/interfaces/intLinkedCompany';
import type { IntUserData } from '@functions/models/interfaces/intUser';
import type { IntUserCompanyData } from '@functions/models/interfaces/intUserCompany';



export const useStoreUser = defineStore( 'storeUser', {

    state: () => ( {
        userData: {} as IntUserData,
        companyData: {} as IntCompanyData,
        userCompanyData: {} as IntUserCompanyData,
        linkedCompanies: [] as IntLinkedCompanyData[],
        isCompanyManager: false,
        isCompanySeller: false,
        isCompanyClient: false,
        isSuperAdmin: false,
        fetching: false,
        loaded: false,
    } ),

    getters: {
        getRole: state => ( state.userCompanyData?.role ? state.userCompanyData?.role : DBRole.USER ),
        getIsCompanyManager: state => state.isCompanyManager,
        getIsCompanySeller: state => state.isCompanySeller,
        getIsCompanyClient: state => state.isCompanyClient,
        getIsSuperAdmin: state => state.isSuperAdmin,
    },
    actions: {
        setStoreUserData ( userData: IntUserData ) {
            this.userData = userData
        },
        setStoreCompanyData ( companyData: IntCompanyData ) {
            this.companyData = companyData
        },
        setStoreUserCompanyData ( userCompanyData: IntUserCompanyData ) {
            this.userCompanyData = userCompanyData
        },
        setStoreUserAndCompanyData ( userData: IntUserData, companyData: IntCompanyData, userCompanyData: IntUserCompanyData ) {
            this.setStoreUserData( userData )
            this.setStoreCompanyData( companyData )
            this.setStoreUserCompanyData( userCompanyData )
        },
        setStoreLinkedCompanies ( linkedCompanies: IntLinkedCompanyData[] ) {
            this.linkedCompanies = linkedCompanies
        },
        setStoreIsCompanyManager ( isCompanyManager: boolean ) {
            this.isCompanyManager = isCompanyManager
        },
        setStoreIsCompanySeller ( isCompanySeller: boolean ) {
            this.isCompanySeller = isCompanySeller
        },
        setStoreIsCompanyClient ( isCompanyClient: boolean ) {
            this.isCompanyClient = isCompanyClient
        },
        setStoreIsSuperAdmin ( isSuperAdmin: boolean ) {
            this.isSuperAdmin = isSuperAdmin
        },
        clearStore () {
            loggerLocal.info( 'clearStore', 'start clearStore' )
            this.userData = {} as IntUserData
            this.companyData = {} as IntCompanyData
            this.userCompanyData = {} as IntUserCompanyData
            this.linkedCompanies = [] as IntLinkedCompanyData[]
            this.isCompanyManager = false
            this.isCompanySeller = false
            this.isCompanyClient = false
            this.isSuperAdmin = false
            this.fetching = false
            this.loaded = false
            loggerLocal.info( 'clearStore', 'StoreUser cleared' )
        }
    },
} )
// make sure to pass the right store definition, `useAuth` in this case.
/*if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStoreUser, import.meta.hot))
}*/
